import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface BranchListItem {
  branchDesc: string;
  branchKey: number;
}

export interface GetBranchListRequestParams {
  divisionKey?: number;
  regionKey?: number;
}

export const getBranchListAPI = (params?: GetBranchListRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetBranchByDivisionRegion`,
  });
};

export type BranchListResponse = BranchListItem[];

export const fetchBranchList = async (params?: GetBranchListRequestParams): Promise<BranchListResponse> => {
  const response: AxiosResponse<BranchListResponse> = await getBranchListAPI(params);
  return response.data;
};
